require("core-js/features/array/find");

import Vue from "vue";
import { mapState } from "vuex";
import { Component } from "vue-property-decorator";
import { INewContractState } from "../../new-contract-vuex-store";
import FormGroupStatic from "../phases/form-group-static.vue";
import HorizontalFormGroup from "../phases/horizontal-form-group.vue";
import { ContactPersonUtils } from "../../../../../Scripts/inpulse/ContactPersonUtils";

@Component({
    components: {
        FormGroupStatic,
        HorizontalFormGroup
    },
    computed: mapState({
        company: (state: INewContractState) => state.contract.Company,
        contract: (state: INewContractState) => state.contract,
        contactPersons: (state: INewContractState) => {
            const res = [];
            state.contract.Company.ContactPersons.forEach(x => {
                if (!ContactPersonUtils.isEmpty(x))
                    res.push(x);
            });
            return res;
        }
    }),
})

export default class CompanyInformationDisplay extends Vue {  
    get offerRequest(): boolean { return this.$store.state.offerRequest; }
}